module.exports = __webpack_public_path__ + "img/fun08.87c1d462.png";